<template>
  <v-col
    cols="12"
    md="12"
    :lg="isDemoUser && !company.id ? 12 : 4"
  >
    <v-card elevation="2">
      <v-card-title>
        <v-row>
          <v-col
            cols="8"
          >
            Компания:
          </v-col>
          <v-col
            cols="3"
          >
            <v-btn
              text
              outlined
              small
              color="dark"
              @click="editMode = !editMode"
            >
              {{ editDataButtonText }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="text--primary">
        <div v-if="!editMode && company.id">
          <p class="account-text-header">Юр. Информация</p>
          <div class="account-text-info">
            <span class="font-weight-medium">Юр. лицо</span>
            {{ company.name }}
          </div>
          <div class="account-text-info">
            <span class="font-weight-medium">Страна:</span>
            {{ company.country_label }}
          </div>
          <div class="account-text-info">
            <span class="font-weight-medium">Город:</span>
            {{ company.city }}
          </div>
          <div class="account-text-info">
            <span class="font-weight-medium">Адрес:</span>
            {{ company.address }}
          </div>
          <div class="account-text-info">
            <span class="font-weight-medium">ОГРН:</span>
            {{ company.ogrnip }}
          </div>
          <div class="account-text-info">
            <span class="font-weight-medium">ИНН:</span>
            {{ company.inn }}
          </div>
          <div
            v-if="!isWholesalePartner"
            class="account-text-info"
          >
            <span class="font-weight-medium">Номер договора:</span>
            {{ company.contract_number }}
          </div>
          <p class="account-text-header">Банковские данные</p>
          <div class="account-text-info">
            <span class="font-weight-medium">Банковский счет:</span>
            {{ company.bank_account }}
          </div>
          <div class="account-text-info">
            <span class="font-weight-medium">Банк:</span>
            {{ company.bank_name }}
          </div>
          <div class="account-text-info">
            <span class="font-weight-medium">БИК:</span>
            {{ company.bank_bik }}
          </div>
          <div class="account-text-info">
            <span class="font-weight-medium">ИНН банка:</span>
            {{ company.bank_inn }}
          </div>
        </div>
        <div v-else-if="!editMode & !company.id">
          <div class="account-text-info">
            <span class="font-weight-medium">Пожалуйста, заполните информацию о компании</span>
          </div>
        </div>
        <div v-else>
          <template v-if="isDemoUser && !company.id">
            <v-row>
              <v-col cols="12" md="4">
                <p class="account-text-header">Персональные данные</p>
                <v-text-field
                  v-model="user.first_name"
                  outlined
                  :rules="nonEmptyRules"
                  label="* Имя"
                >
                </v-text-field>
                <v-text-field
                  v-model="user.last_name"
                  outlined
                  :rules="nonEmptyRules"
                  label="* Фамилия"
                >
                </v-text-field>
                <v-text-field
                  v-model="user.email"
                  outlined
                  :rules="emailRules"
                  label="* Почта"
                  type="email"
                >
                </v-text-field>
                <v-text-field
                  v-model="user.phone"
                  outlined
                  :rules="phoneRules"
                  label="* Телефон"
                  type="tel"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <p class="account-text-header">Юр. Информация</p>
                <v-text-field
                  v-model="company.name"
                  outlined
                  required
                  label="* Юр. лицо"
                  :rules="nonEmptyRules"
                >
                </v-text-field>
                <v-select
                  v-model="company.country"
                  :rules="nonEmptyRules"
                  item-text="state"
                  item-value="abbr"
                  :items="countries"
                  outlined
                  required
                  persistent-hint
                  single-line
                  prepend-inner-icon="mdi-earth"
                  label="* Страна"
                >
                </v-select>
                <v-text-field
                  v-model="company.city"
                  outlined
                  :rules="nonEmptyRules"
                  required
                  label="* Город"
                >
                </v-text-field>
                <v-text-field
                  v-model="company.address"
                  outlined
                  :rules="nonEmptyRules"
                  label="* Адрес"
                  required
                >
                </v-text-field>
                <v-text-field
                  v-model="company.ogrnip"
                  outlined
                  :rules="ogrnRules"
                  required
                  label="* ОГРН"
                >
                </v-text-field>
                <v-text-field
                  v-model="company.inn"
                  outlined
                  :rules="innRules"
                  required
                  label="* ИНН"
                >
                </v-text-field>
                <v-text-field
                  v-if="!isWholesalePartner"
                  v-model="company.contract_number"
                  outlined
                  label="Номер договора"
                />
              </v-col>
              <v-col cols="12" md="4">
                <p class="account-text-header">Банковские данные</p>
                <v-text-field
                  v-model="company.bank_account"
                  outlined
                  label="Банковский счет"
                />
                <v-text-field
                  v-model="company.bank_name"
                  outlined
                  label="Банк"
                />
                <v-text-field
                  v-model="company.bank_bik"
                  outlined
                  :rules="bikRules"
                  maxlength="9"
                  label="БИК"
                />
                <v-text-field
                  v-model="company.bank_inn"
                  outlined
                  :rules="bankInnRules"
                  label="ИНН банка"
                />
              </v-col>
            </v-row>
            <v-btn
              text
              outlined
              color="dark"
              @click="saveAccountCompany"
            >
              Сохранить
            </v-btn>
          </template>
          <template v-else>
            <p class="account-text-header">Юр. Информация</p>
            <v-text-field
              v-model="company.name"
              outlined
              required
              label="* Юр. лицо"
              :rules="nonEmptyRules"
            >
            </v-text-field>
            <v-select
              v-model="company.country"
              :rules="nonEmptyRules"
              item-text="state"
              item-value="abbr"
              :items="countries"
              outlined
              required
              persistent-hint
              single-line
              prepend-inner-icon="mdi-earth"
              label="* Страна"
            >
            </v-select>
            <v-text-field
              v-model="company.city"
              outlined
              :rules="nonEmptyRules"
              required
              label="* Город"
            >
            </v-text-field>
            <v-text-field
              v-model="company.address"
              outlined
              :rules="nonEmptyRules"
              label="* Адрес"
              required
            >
            </v-text-field>
            <v-text-field
              v-model="company.ogrnip"
              outlined
              :rules="ogrnRules"
              required
              label="* ОГРН"
            >
            </v-text-field>
            <v-text-field
              v-model="company.inn"
              outlined
              :rules="innRules"
              required
              label="* ИНН"
            >
            </v-text-field>
            <v-text-field
              v-if="!isWholesalePartner"
              v-model="company.contract_number"
              outlined
              label="Номер договора"
            />
            <p class="account-text-header">Банковские данные</p>
            <v-text-field
              v-model="company.bank_account"
              outlined
              label="Банковский счет"
            />
            <v-text-field
              v-model="company.bank_name"
              outlined
              label="Банк"
            />
            <v-text-field
              v-model="company.bank_bik"
              outlined
              :rules="bikRules"
              maxlength="9"
              label="БИК"
            />
            <v-text-field
              v-model="company.bank_inn"
              outlined
              :rules="bankInnRules"
              label="ИНН банка"
            />
            <v-btn
              text
              outlined
              color="dark"
              @click="saveAccountCompany"
            >
              Сохранить
            </v-btn>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import account from "@/api/account";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CompanyInfoCard",
  props: {
    phoneRules: {
      type: Array,
    },
    emailRules: {
      type: Array,
    },
    nonEmptyRules: {
      type: Array,
    },
  },
  data() {
    return {
      company: {
        id: '',
        name: '',
        country: '',
        city: '',
        address: '',
        contract_date: '',
        ogrnip: '',
        inn: '',
        contract_number: '',
        company_type: '',
        bank_account: '',
        bank_name: '',
        bank_bik: '',
        bank_inn: '',
      },
      user: {
        id: '',
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
      },
      selectedCountry: {
        state: 'Россия',
        abbr: 'RU'
      },
      countries: [
        {state: 'Россия', abbr: 'RU'},
        {state: 'Казахстан', abbr: 'KZ'},
        {state: 'Белоруссия', abbr: 'BY'},
      ],
      editMode: false,
    }
  },
  computed: {
    ...mapGetters("auth", ["isDemoUser", "isWholesalePartner"]),
    editDataButtonText() {
      return this.editMode ? 'Отменить' : 'Изменить';
    },
    ogrnRules() {
      return [
        v => !!v || 'Это поле нужно заполнить',
        v => /^\d{10,15}$/.test(v) || 'ОГРН должен содержать от 10 до 15 цифр',
      ]
    },
    innRules() {
      return [
        v => !!v || 'Это поле нужно заполнить',
        v => (/^\d{10}$/.test(v) || /^\d{12}$/.test(v)) || 'ИНН должен содержать 10 или 12 цифр',
      ]
    },
    bankInnRules() {
      return [
        v => !v || (/^\d{10}$/.test(v) || /^\d{12}$/.test(v)) || 'ИНН банка должен содержать 10 или 12 цифр',
      ]
    },
    bikRules() {
      return [
        v => !v || /^\d{9}$/.test(v) || 'БИК должен содержать 9 цифр',
      ]
    },
  },
  created() {
    this.initData();
  },
  methods: {
    ...mapActions("auth", ["updateUserinfo"]),
    ...mapActions(["alertSuccess", 'alertError']),
    validateCompanyInfo: function () {
      if (this.company.name &&
        this.company.country &&
        this.company.city &&
        this.company.address &&
        this.company.ogrnip &&
        this.company.inn &&
        (!this.isDemoUser || (this.user.first_name && this.user.last_name && this.user.email && this.user.phone))) {
        return true;
      }
      this.alertError('Пожалуйста, заполните все обязательные поля');
      return false;
    },
    saveAccountCompany: async function () {
      if (!this.validateCompanyInfo()) {
        return;
      }
      if (this.isDemoUser && !this.company.id) {
        await this.demoSetupCompanyAndUser();
        return;
      }
      if (this.company.id) {
        await this.updateUserCompany();
        return;
      }
      await this.createUserCompany();
    },
    updateUserCompany: async function () {
      try {
        const response = await account.changeAccountCompanyInfo(this.company);
        this.company = response.data;
        this.editMode = false;
      } catch (e) {
        console.log(e);
      }
    },
    async initData() {
      await this.getCompanyInfo();
      if (this.isDemoUser) {
        await this.getUserInfo();
      }
      if (this.isDemoUser && !this.company.id) {
        this.editMode = true;
      }
    },
    createUserCompany: async function () {
      try {
        const response = await account.createAccountCompanyInfo(this.company);
        this.company = response.data;
        this.editMode = false;
        await this.updateUserinfo();
        this.$emit('user-data-changed');
      } catch (e) {
        console.log(e);
      }
    },
    getCompanyInfo: async function () {
      try {
        const response = await account.getAccountCompanyInfo();
        this.company = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getUserInfo() {
      try {
        const response = await account.getAccountUserInfo();
        this.user = response.data;
        if (this.isDemoUser && typeof this.user.email === 'string' && this.user.email.endsWith('@portal.invalid')) {
          this.user.email = '';
        }
      } catch (e) {
        console.log(e);
      }
    },
    async demoSetupCompanyAndUser() {
      try {
        const payload = {
          company: {
            name: this.company.name,
            country: this.company.country,
            city: this.company.city,
            address: this.company.address,
            ogrnip: this.company.ogrnip,
            inn: this.company.inn,
            bank_account: this.company.bank_account,
            bank_name: this.company.bank_name,
            bank_bik: this.company.bank_bik,
            bank_inn: this.company.bank_inn,
          },
          user: {
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            email: this.user.email,
            phone: this.user.phone,
          },
        };
        const response = await account.demoSetupCompanyAndUser(payload);
        this.company = response.data.company;
        this.user = response.data.user;
        this.editMode = false;
        await this.updateUserinfo();
        this.$emit('user-data-changed', this.user);
      } catch (e) {
        console.log(e);
      }
    },
    setSelectedCountry() {
      this.company.country = this.selectedCountry.abbr
    },
  },
}
</script>

<style scoped>
.account-text-info {
  margin-bottom: 0.5rem;
  font-size: 1rem;
}

.account-text-header {
  font-size: 1.2rem;
  font-weight: 400;
  color: darkgrey;
  padding-bottom: 0.1rem;
  margin-bottom: 0.5rem;
  padding-top: 0.5rem;
  margin-left: -0.5rem;
}
</style>
